<mat-form-field appearance="outline" class="w-5/6 !-mb-[1.25em]">
    <mat-select
        [formControl]="form.controls.userId"
        panelWidth="w-full"
        canSelectNullableOptions
    >
        @for (advisor of advisorDropdownOptions; track advisor.value) {
            <mat-option [value]="advisor.value">
                {{ advisor.label }}
            </mat-option>
        }
    </mat-select>
</mat-form-field>
